// extracted by mini-css-extract-plugin
export default {"shopping-cart-total-card":"ShoppingCartTotal_shopping-cart-total-card__rm0KX","indent":"ShoppingCartTotal_indent__CvYmx"};